// extracted by mini-css-extract-plugin
module.exports = {"form":"Register_form__2kAkG","input":"Register_input__2S12F","error":"Register_error__1Xvsd"};